module.exports = __webpack_public_path__ + "Flama-BasicItalic.woff2?3f6d7e9862c4889b84c7f52ef66e1d6a";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BasicItalic.woff2
// module id = 887
// module chunks = 0